
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-livewidget
* (C) Copyright IBM Corp. 2018, 2021
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'testString': 'テスト',
	'visualizationSlideoutTitle': '視覚化',
	'listSeparator': ',',
	'pointSeparator': ':',
	'minValuePlaceholder': '数値を入力してください',
	'maxValuePlaceholder': '数値を入力してください',
	'customRangeErrorMessage': '値は数値である必要があります',
	'propFillColor': '塗りつぶし色',
	'propBorderColor': '罫線の色',
	'propColorPalette': '現在のカラー・パレット',
	'propColorPaletteChangeLabel': 'カラー・パレットの変更',
	'propNewColorPaletteLabel': 'カスタム・カラー・パレットの作成',
	'propNewHeatPaletteLabel': 'カスタム熱パレットの作成',
	'propDonutRadius': 'ドーナツ・グラフの半径',
	'showTitleLabel': 'タイトルを表示',
	'titleTypeLabel': 'タイトル・タイプ',
	'smartTitleLabel': 'スマート・タイトル',
	'customTitleLabel': 'カスタム・タイトル',
	'noTitleLabel': 'タイトルなし',
	'propHeatScalePalette': '現在の熱パレット',
	'propHeatPaletteChangeLabel': '熱パレットの変更',
	'propMaintainAxisScales': '軸スケールを維持',
	'propLineAndSymbolColor': '線とシンボルの色',
	'propLineAndSymbolPalette': '線とシンボルのカラー・パレット',
	'propElementColor': '要素の色',
	'propColumnColor': '縦棒の色',
	'propColumnPalette': '列のカラー・パレット',
	'propColumnHeatPalette': '縦棒の熱パレット',
	'propBarColor': 'バーの色',
	'propGoalColor': '目標を表す色',
	'propToColor': '終点の色',
	'propFromColor': '始点の色',
	'propNumberValidationErrorMessageId': '数値を入力してください',
	'fontSizeAuto': '自動',
	'propAutoBinCount': 'グループ数',
	'propAutoBinToggle': '自動グループ化',
	'tabName_general': '全般',
	'tabName_visDetails': '詳細',
	'tabName_animation': 'アニメーション',
	'tabName_mediaDetails': 'メディアの詳細',
	'tabName_webDetails': 'Web ページの詳細',
	'tabName_imageDetails': '画像の詳細',
	'tabName_visualization': '視覚化',
	'tabName_text': 'テキスト',
	'sectionName_colorsAndThemes': '色とテーマ',
	'sectionName_appearance': '外観',
	'sectionName_general': '全般',
	'sectionName_colorPalette': '色',
	'sectionName_axis': '軸',
	'sectionName_axis_label': '軸',
	'sectionName_legend': '凡例',
	'sectionName_chart': 'グラフ',
	'sectionName_regionLayer': '地域レイヤー',
	'sectionName_pointLayer': 'ポイント・レイヤー',
	'sectionName_latLongLayer': '緯度/経度レイヤー',
	'sectionName_pathLayer': 'パス・レイヤー',
	'sectionName_xAxis': 'X 軸',
	'sectionName_yAxis': 'Y 軸',
	'sectionName_xAxis_title': 'X 軸タイトル',
	'sectionName_yAxis_title': 'Y 軸タイトル',
	'sectionName_xAxis_label': 'X 軸ラベル',
	'sectionName_yAxis_label': 'Y 軸ラベル',
	'sectionName_column_yAxis': '列 Y 軸',
	'sectionName_column_yAxis_label': '列 Y 軸レベル',
	'sectionName_column_yAxis_title': '列 Y 軸タイトル',
	'sectionName_line_yAxis': '行 Y 軸',
	'sectionName_line_yAxis_label': '行 Y 軸ラベル',
	'sectionName_line_yAxis_title': '行 Y 軸タイトル',
	'sectionName_title': 'タイトル',
	'sectionName_dataValueLabels': 'データ値ラベル',
	'sectionName_style': 'スタイル',
	'propTransparencyDescription': 'オブジェクトの透明度を調整します。 0 から 100 までの値を入力してください',
	'smart_annotation_unauthorized': '注釈: 無許可アクセス',
	'smart_annotation_method': '注釈: メソッドが許可されていません',
	'smart_annotation_media': '注釈: メディア・タイプが許可されていません',
	'smart_annotation_input': '注釈: 入力が無効です',
	'smart_annotation_internal': '注釈: 内部システム・エラー',
	'smart_annotation_generic_error': '注釈: サービス・エラー',
	'smart_annotation_dialog_title': '洞察',
	'smart_annotation_Show_Insights': '洞察の表示',
	'smart_annotation_Relationship': '関係は',
	'forecast_enter_number': '次の間の数値を入力',
	'and': ' と ',
	'smart_errors': '注釈のエラー:',
	'smart_warnings': '注釈の警告:',
	'smart_annotation_insight_icon_title': '洞察',
	'smart_annotations_toggle_on': '洞察をオンにする',
	'smart_annotations_toggle_off': '洞察をオフにする',
	'smart_annotation_toggle_on': 'トグルをオン',
	'smart_annotation_toggle_off': 'トグルをオフ',
	'smart_annotation_insight_unavailable': '洞察は現在使用できません',
	'smart_annotation_insight_topBottom_percent_unsupported': '上位または下位 % のフィルターが適用されている場合、洞察は使用できません',
	'smart_annotation_forecast_topBottom_percent_unsupported': '上位または下位 % のフィルターが適用されている場合、予測は使用できません',
	'smart_annotation_insight_topBottom_nested_dataItem_unsupported': '上位または下位のフィルターが適用されていて、複数の列がフィールドにある場合、洞察は使用できません',
	'smart_annotation_forecast_topBottom_nested_dataItem_unsupported': '上位または下位のフィルターが適用されていて、複数の列がフィールドにある場合、予測は使用できません',
	'forecast_title': '予測',
	'forecast_show': '予測の表示',
	'forecast_toggle_on': '予測をオンにする',
	'forecast_toggle_off': '予測をオフにする',
	'statDetailsPerspectiveTitle': '分析',
	'emptyStatDetailsPanel': '現在の視覚化に関する追加分析はありません。',
	'predict_errors': '分析のエラー',
	'predict_warnings': '分析の警告',
	'fpd_invalid_data_source': 'このデータ・ソースには関連付けられたスマート・モジュールがありません',
	'fpd_network_issue': 'このデータ・ソースに対する分析の実行には問題がありました',
	'fpd_data_source_category': 'スマート・モジュールが欠落しています',
	'fpd_response_errors': '推奨ドライバーのエラー',
	'fpd_response_warnings': '推奨ドライバーの警告',
	'catalyst_service_bad_request': '正しくない要求',
	'catalyst_service_unkown_Id': '不明な要求 ID が見つかりました',
	'catalyst_service_internal_server_error': '内部サーバー・エラー',
	'catalyst_service_generic_error': 'Catalyst サービス・エラー',
	'catalyst_service_error': 'このサービスは現在使用できません',
	'propLegendPosition': '凡例の位置',
	'propLeft': '左',
	'propRight': '右',
	'propTop': '上位',
	'propBottom': '下位',
	'propNone': 'なし',
	'propLegendDisplay': '凡例の表示',
	'targetThicknessPlaceHolder': '%{min} から %{max} まで',
	'targetThicknessErrorMsg': '%{min} から %{max} までの範囲内の整数を入力してください。',
	'possibleKeyDriver_DialogDriversLabelBegin': 'ドライバー (',
	'possibleKeyDriver_DialogDriversLabelEnd': '選択済み)',
	'possibleKeyDriver_DialogDriversLabelDivider': '/',
	'possibleKeyDriver_DialogDriversResetToDefaultsLabel': 'デフォルトにリセット',
	'possibelKeyDriver_AddNewDrivers': 'ドライバーの追加',
	'possibleKeyDrivers_NonRecommended_Placeholder': 'ドライバーを検索して追加',
	'possibleKeyDrivers_MaxPossibleReached': '別のドライバーを追加または選択するには、ドライバーを選択解除してください',
	'possibleKeyDrivers_Recommended': '推奨',
	'visRecommendedTypes': '推奨視覚化タイプ',
	'visRecommender_smartsfailure': '視覚化の推奨は現在使用できません',
	'visMore': 'その他...',
	'visMoreTooltip': 'その他の視覚化',
	'visOtherTypes': 'その他の視覚化タイプ',
	'visChange': '視覚化の変更',
	'automaticTypeCaption': '自動',
	'propVisType': '視覚化タイプ',
	'dlg_loading': 'ロードしています...',
	'snippetListChartCaption': 'スニペット・リスト',
	'convoClusterChartCaption': '対話クラスター',
	'areaChartCaption': '面グラフ',
	'barChartCaption': '横棒グラフ',
	'columnChartCaption': '列',
	'stackedbarChartCaption': '積み重ね棒',
	'stackedcolumnChartCaption': '積み重ね列',
	'bubbleChartCaption': 'バブル・チャート',
	'marimekkoChartCaption': 'マリメッコ・グラフ',
	'cometChartCaption': 'ドライバー分析',
	'scatterChartCaption': '散布グラフ',
	'lineChartCaption': '線',
	'pointChartCaption': '点グラフ',
	'heatChartCaption': 'ヒート・マップ',
	'bulletChartCaption': 'ブレット',
	'waterfallChartCaption': 'ウォーターフォール',
	'radarChartCaption': 'レーダー・チャート',
	'boxplotChartCaption': '箱ひげ図',
	'pieChartCaption': '円グラフ',
	'mapChartCaption': '地図',
	'radialBarChartCaption': '放射状グラフ',
	'compositeChartCaption': '折れ線と縦棒',
	'wordCloudChartCaption': 'ワード・クラウド',
	'networkChartCaption': 'ネットワーク',
	'relationshipNetworkChartCaption': '関係ネットワーク',
	'treemapChartCaption': 'ツリー・マップ',
	'packedBubbleChartCaption': 'パック・バブル',
	'hierarcicalPackedBubbleChartCaption': '階層バブル',
	'spiralChartCaption': 'スパイラル',
	'decisionTreeChartCaption': 'デシジョン・ツリー',
	'legacyMapChartCaption': '既存の地図',
	'sunburstChartCaption': 'サンバースト',
	'visUsageComparison': '比較',
	'visUsageRelationships': '関係',
	'visUsageTrend': 'トレンド',
	'visUsagePartsToWhole': '部分と全体の関係',
	'visUsageGeospatial': '地理情報',
	'visUsageAdvanced': '拡張分析',
	'visUsageTablesAndSummary': '表と集計',
	'visUsageSocialInsights': 'ソーシャル・インサイト',
	'visUsageOther': 'その他',
	'autoBinActionText': '自動グループ化',
	'filterAutobinActionText': 'ビンのフィルター',
	'memberCalculationActionText': 'メンバー計算',
	'toolbarActionCalculation': '計算式を作成',
	'toolbarActionEditCalculation': '計算式の編集',
	'topBottomRankLabel': 'ランク (%{label})',
	'toolbarDeleteFilterActionText': 'フィルターの削除',
	'toolbarActionTopKeyDrivers': 'ドライバーの表示',
	'toolbarActionCustomGroup': 'カスタム・グループ',
	'canNotCreateCustomGroup': 'このカスタム・グループを作成できません。',
	'aria_label_datatable': 'データ表',
	'summaryCaption': '集計',
	'MeasuresCaption': '数値データ',
	'MeasuresGroupCaption': '数値データのグループ (%{count})',
	'ValuesCaption': '値',
	'turnInsightsOn': '洞察をオンにする',
	'turnInsightsOff': '洞察をオフにする',
	'decisionRules': '規則',
	'decisionTree': 'ツリー図',
	'decisionSunburst': 'ツリー・サンバースト',
	'switchToDecisionRules': 'デシジョン規則に切り替え',
	'switchToDecisionTree': 'デシジョン・ツリーに切り替え',
	'data_group_less_then': '%{rangeTo} より小',
	'data_group_to': '%{rangeFrom} から < %{rangeTo} まで',
	'data_group_and_above': '%{rangeFrom} 以上',
	'nullValueContent': '(値なし)',
	'sum': '合計',
	'count': '個数',
	'countdistinct': '重複値を除くデータの個数',
	'avg': '平均',
	'min': '最小値',
	'max': '最大値',
	'automatic': 'カスタム',
	'variance': '差異',
	'stddev': '標準偏差',
	'median': '中央値',
	'calculated': '計算結果',
	'none': 'なし',
	'measureLabel': '%{measureName}',
	'multiMeasureLabel': '%{measureName} (%{aggregate})',
	'aggregatedColumnLabel': '%{column} (%{aggregationTypeLabel})',
	'promptTitle': 'プロンプト値',
	'inputLabelPrompt': '値',
	'inputPlaceholderPrompt': '値を入力',
	'inputInvalidText': '%{dataType} タイプの入力が無効です',
	'unSupportedPrompt': 'サポートされないプロンプト',
	'missingDataSource': '適切なデータ・ソースが見つかりませんでした。',
	'unSupportedPromptType': 'プロンプト・シナリオは現在、サポートされていません。',
	'preAggregateLabel': 'データ・ソースからプロンプト値を適用',
	'postAggregateLabel': 'レポートのプロンプト値を適用',
	'preAggregateText': '範囲はデータ・ソース内の値を使用します。ダッシュボードに表示されている値ではありません。',
	'defaultAggregation_count': '個数',
	'defaultAggregation_countdistinct': '重複値を除くデータの個数',
	'defaultAggregation_max': '最大値',
	'defaultAggregation_min': '最小値',
	'defaultAggregation_avg': '平均',
	'defaultAggregation_sum': '合計',
	'defaultAggregation_auto': '自動 (%{aggregationType})',
	'keydriver_average': '全体の平均',
	'keydriver_up_down': '高平均または低平均の強調表示されたグループは、ターゲットに対してより大きな影響を及ぼします。 異常な高平均または低平均のグループは、非常に大きな影響を及ぼします。',
	'keydriver_different': '強調表示されたグループは、分布が全体的な分布と大幅に異なっています。 これらのグループは、ターゲットに対してより大きな影響を及ぼします。',
	'topOperator': '上位',
	'bottomOperator': '下位',
	'topBottomFact': '%{columnLabel} 別の %{operator} %{value}%{percent}',
	'topBottomDimension': '%{operator} %{value}%{percent}',
	'deleteTopBottomCount': '上位または下位件数を削除',
	'deleteTopBottomPercent': '上位または下位 % を削除',
	'topBottomTitle': 'このオブジェクトのみ',
	'deleteTopBottom': '上位または下位件数を削除',
	'editTopBottom': '上位または下位件数を編集',
	'editTopBottomCount': '上位または下位件数を編集',
	'editTopBottomPercent': '上位または下位 % を編集',
	'ariaDeleteTopBottomCountLabel': '上位または下位件数を削除するには DELETE キーを押します。',
	'ariaDeleteTopBottomPercentLabel': '上位または下位 % を削除するには DELETE キーを押します。',
	'ariaEditTopBottomCountLabel': '上位または下位件数を編集するには ENTER キーを押します。',
	'ariaEditTopBottomPercentLabel': '上位または下位 % を編集するには ENTER キーを押します。',
	'ariaDeleteDrillStateLabel': '上位または下位件数を編集するには ENTER キーを押します。',
	'drillUpStateTitle': 'ドリルアップ',
	'drillDownStateTitle': 'ドリルダウン',
	'ariaEditTopBottomLabel': '上位または下位件数を編集するには ENTER キーを押します。',
	'ariaDeleteTopBottomLabel': '上位または下位件数を削除するには DELETE キーを押します。',
	'allKeyDriversLabel': '自動 (全ドライバー)',
	'filter_drag_and_drop_single_dock': 'フィルターにかけるには、データをここにドラッグ・アンド・ドロップします。',
	'filter_drag_and_drop_all_tabs': 'すべてのタブをフィルターにかけるには、データをここにドラッグ・アンド・ドロップします。',
	'filter_drag_and_drop_current_tab': 'このタブをフィルターにかけるには、データをここにドラッグ・アンド・ドロップします。',
	'filter_empty_consume_mode': 'フィルターは適用されていません。',
	'filterClearAllItems': 'フィルターをすべてクリア',
	'filterDeleteAllItems': 'フィルターをすべて削除',
	'filterDockChevronLeft': 'データをスクロールします',
	'filterDockChevronRight': 'データをスクロールします',
	'filterIconLabel_Single': 'フィルター',
	'filterIconLabel_Global': 'すべてのタブ',
	'filterIconLabel_Tab': 'このタブ',
	'filterIconTooltip_Single': 'フィルター',
	'filterIconTooltip_Global': 'すべてのタブのフィルター',
	'filterIconTooltip_Tab': 'このタブのフィルター',
	'filterDropZoneTooltip_Single': 'フィルター・ドロップ・ゾーン',
	'filterDropZoneTooltip_Global': 'すべてのタブのフィルター・ドロップ・ゾーン',
	'filterDropZoneTooltip_Tab': 'このタブのフィルター・ドロップ・ゾーン',
	'filterOverflowMenu': '詳細表示',
	'expand': '展開',
	'collapse': '省略',
	'filterDockItemNameAriaLabel': 'Enter を押してフィルター・ダイアログを開き、フィルターを定義してください。',
	'filterItemCanvasMove': 'キャンバスに追加',
	'filterItemDelete': 'フィルターの削除',
	'filterInvertRange': '次を除くすべて: %{from}-%{to}',
	'filterRange': '%{from}-%{to}',
	'filter_date_after_except': '%{from} の後ではない',
	'filter_date_after': '%{from} の後',
	'filter_date_before_except': '%{to} の前ではない',
	'filter_date_before': '%{to} の前',
	'filter_date_between_except': '%{from}-%{to} の範囲外',
	'filter_date_between': '%{from}-%{to} の間',
	'filterValueSeparator': ',',
	'filterAll': 'すべて',
	'filter': 'フィルター',
	'filterExcept': '%{values} 以外',
	'filterDockToolbarButtonLabel': 'フィルター・ドック',
	'navigateTitle': 'ナビゲート先',
	'navigateSelectColumn': '列の選択',
	'navigateSelectPath': 'ナビゲーション・パスの選択',
	'current_nav_group': '現在のナビゲーション・グループは %{navigation_group_name} です',
	'next': '次へ',
	'previous': '戻る',
	'multiselectMsg': '%{count} 個を選択済み',
	'errMsgFilterItemMissingTitle': 'フィルター値 %{itemName} は、このデータ・セットでは使用できないため、ロードできません',
	'errMsgFilterItemGenericTitle': 'フィルター値をロードできません',
	'textFilterItemsNotFound': '使用可能なアイテムがありません。',
	'nullValueLabel': '(ブランク)',
	'filterConditionLabel': 'フィルター条件',
	'filter_includesAll': 'すべて含める',
	'filter_allMembersOfSet': 'セット内のすべてのメンバー',
	'modelFilter': 'フィルター',
	'filtersTitle': 'プロパティーのフィルター',
	'search': '検索',
	'clearTextFilterValue': 'クリア',
	'invertFilterSelection': '反転',
	'modellingLoading': 'ロードしています...',
	'searchAll': 'すべての列を検索',
	'toolbarActionPossibleKeyDrivers': '範囲の編集',
	'toolbarActionPossibleKeyDriversSubTitle': 'ドライバー分析グラフで検討する項目を左側からドラッグします',
	'toolbarActionSort': 'ソート',
	'toolbarActionSortAscending': '昇順',
	'toolbarActionSortDescending': '降順',
	'toolbarActionSortAuto': '自動 (%{sortOrder})',
	'toolbarActionSortCustom': 'カスタム',
	'toolbarActionFormat': 'データ表示形式を設定',
	'toolbarActionFormatText': 'データ表示形式を設定 (テキスト)',
	'toolbarActionFormatAbbreviation': '簡略',
	'toolbarActionFormatNone': '自動',
	'toolbarActionFilter': 'フィルター',
	'toolbarActionTopBottom': '上位または下位',
	'toolbarActionRmvShape': '形状の削除',
	'toolbarActionToggleShapeDrop': 'インフォグラフィックの形状',
	'toolbarActionToggleShapeDropTitle': 'インフォグラフィックの作成',
	'toolbarActionToggleShapeDropText': '形状をこのフィールドにドラッグしてインフォグラフィックを作成します。',
	'toolbarActionAggregationType': '要約',
	'toolbarDeleteActionText': '列の削除',
	'toolbarTextActionText': 'スタイル・テキスト',
	'toolbarActionFilterLocalKeepSelected': '維持',
	'toolbarActionFilterLocalExcludeSelected': '除外',
	'toolbarActionFilterAllKeepSelected': 'フィルター',
	'toolbarActionSimpleCalculation': '単純な計算',
	'toolbarActionDrillBack': '戻る',
	'toolbarActionDrillUp': 'ドリルアップ',
	'toolbarActionDrillDown': 'ドリルダウン',
	'toolbarActionJumpTo': 'ドリルスルー',
	'toolbarActionNavigate': 'ナビゲート',
	'toolbarActionCreateFilterGroup': '接続の新規作成',
	'toolbarActionDisconnectFilterGroup': 'すべてのリンクを解除',
	'toolbarActionLinkFilterGroup': '既存の接続に追加',
	'toolbarActionLassoSelect': 'ツールの選択',
	'toolbarActionRefreshDeveloperWidget': '更新',
	'textFontFamilySubClassHairline': '超極細',
	'textFontFamilySubClassThin': '細い',
	'textFontFamilySubClassThinItalic': '極細の斜体',
	'textFontFamilySubClassExtraLight': '細字',
	'textFontFamilySubClassExtraLightItalic': '細字の斜体',
	'textFontFamilySubClassLight': '明るい',
	'textFontFamilySubClassLightItalic': '中細の斜体',
	'textFontFamilySubClassRegular': '標準',
	'textFontFamilySubClassRegularItalic': '標準の斜体',
	'textFontFamilySubClassItalic': '斜体',
	'textFontFamilySubClassMedium': '標準の書式',
	'textFontFamilySubClassMediumItalic': '中字の斜体',
	'textFontFamilySubClassHeavy': '超極太',
	'textFontFamilySubClassHeavyItalic': '超極太の斜体',
	'textFontFamilySubClassDemiBold': '中太',
	'textFontFamilySubClassDemiBoldItalic': '中太の斜体',
	'textFontFamilySubClassBold': '太字',
	'textFontFamilySubClassBoldItalic': '太字の斜体',
	'textFontFamilySubClassExtraBold': '極太',
	'textFontFamilySubClassExtraBoldItalic': '極太の斜体',
	'textFontFamilySubClassBlack': '黒',
	'textFontFamilySubClassBlackItalic': '黒の斜体',
	'textFontFamilySubClassStencil': 'ステンシル',
	'dlg_ascending': '昇順',
	'dlg_descending': '降順',
	'dlg_custom': 'カスタム',
	'dlg_none': 'なし',
	'dlg_hierarchy': '階層',
	'dlg_namedSet': '名前付きセット',
	'dlg_rank': 'rank',
	'visualizationLabel': '視覚化',
	'chartLabel': '%{chartName} グラフ',
	'dataWidgetDescription': '%{widgetLabel}: %{columnNames}',
	'f12KeyDescription': 'ウィジェット内でナビゲートするには F12 を押します',
	'f10KeyDescription': 'ウィジェットのフォーカス・ビューを起動するには F10 を押します',
	'playButtonLabel': '再生',
	'dataPlayerValueListLabel': 'データ・プレイヤー値',
	'localFilterTitle': 'このオブジェクトのみ',
	'globalFilterTitle': 'すべてのオブジェクト',
	'deleteFilter': 'フィルターの削除',
	'editFilter': 'フィルターの編集',
	'ariaEditFilterLabel': 'フィルターを編集するには ENTER キーを押します。',
	'ariaDeleteFilterLabel': 'フィルターを削除するには DELETE キーを押します。',
	'measureFilterBetween': '%{lowerBound} と %{upperBound} の間',
	'measureFilterNotBetween': '%{lowerBound} から %{upperBound} の範囲外',
	'dimFilterIn': '包含: %{in}',
	'dimFilterNotIn': '除外: %{out}',
	'gtFilter': '%{lowerBound} の後',
	'ltFilter': '%{upperBound} の前',
	'ariaEditPrompt': 'プロンプト値を変更するには ENTER キーを押してください',
	'dataPointFilterTitle': 'データ・ポイント',
	'dataPointFilterIncludeSummary': '%{valueCount} データ・ポイントを含む',
	'dataPointFilterExcludeSummary': '%{valueCount} データ・ポイントを含まない',
	'widgetFiltersLabel': 'ウィジェット・フィルター',
	'coachMarkTitleSpiralTarget': '範囲の編集',
	'coachMarkContentSpiralTarget': 'ここでターゲットのドライバー選択にアクセスして変更することができます。',
	'srILVTreeLabel': 'リスト',
	'geomapUnrecognizedLocations': '認識していない場所:',
	'geomapAmbiguousLocations': 'あいまいな地域:',
	'visualizationNotifications': '視覚化の通知:',
	'dataNotifications': 'データの通知:',
	'autobinSuggestion': '自動グループ化をオンにする',
	'LIVE_empty_visualization_hint_title': '視覚化の作成',
	'LIVE_empty_visualization_hint_description': 'この位置またはフィールドにデータをドラッグします。',
	'LIVE_slots_required_field_description': '%{asterisk} は必須フィールドを示します',
	'LIVE_slots_drag_and_drop_description': '上のフィールドにデータをドラッグ・アンド・ドロップし、視覚化を作成してフィルターに掛けます。',
	'dwErrorLoadingAvailableVisualizations': '使用可能な視覚化定義をロードできません',
	'moreDataIndicator': 'データは %{threshold} アイテムの位置で切り取られました。より少ない表示にするにはフィルターを適用します。',
	'nonCtxTopBottomInvalid': 'クロス集計にコンテキストなしで上位下位の規則を定義することはサポートされていません。この規則は、このクロス集計ビューから削除されました。%{columnName} のコンテキスト内の 1 つ以上のカテゴリーに対して規則を再定義してください。',
	'dwErrorLoadingVisualizationNotFound': 'オブジェクトをロードできません。オブジェクトに視覚化定義が欠落しています。',
	'dwErrorLoadingVisualizationListNotFound': '視覚化をロードできません。',
	'dwErrorRunningQuery': 'データ・セット %{datasetName} からデータを取得できません。',
	'dwErrorGeoData': '地図に地理データを表示する際に問題が発生しました。 別の視覚化タイプを選択してください。',
	'dwPromptSignonCancelWarning': 'この視覚化のデータは利用不可です。 正しい資格情報を指定してください。',
	'dwErrorMissingDataset': '視覚化をロードできません。その関連データ・セット "%{datasetName}" が使用不可です。',
	'dwErrorRenderingVisualization': 'この視覚化をロードできません。',
	'dwErrorVisualizationTooSmall': '視覚化が小さすぎるため、内容のデータを表示できません。 視覚化を大きくするか、内容のデータを制限してください。',
	'errorSourceNotFound': '視覚化をロードできません。その関連ソース "%{sourceName}" が使用不可です。',
	'errorActionNotSupported': 'データ・ソース "%{sourceName}" では、この操作はサポートされていません。',
	'errorMeasureNotSupportedOnMultiEdges': '視覚化の複数のエッジに数値データがあります。これはサポートされなくなりました。数値データは 1 つのエッジのみに配置してください。',
	'errorExceedAllowableValue': 'セルの推定数が許容値 100000 を超えています。射影されたセットにフィルターを適用してセルの数を減らしてください。',
	'propScaleLabel': 'アイコン数',
	'propScaleDescription': 'アイコン数の選択',
	'propScaleFew': '最小',
	'propScaleDefault': 'デフォルト',
	'propScaleMany': '最大',
	'lastRefresh': '最後の最新表示: %{timeInterval} 前',
	'widgetTimer': 'ウィジェット・タイマー',
	'datasetItemsUnavailable': 'この視覚化で使用されているデータ・セット項目の一部が使用不可です。',
	'datasetItemUnavailable': 'このデータ・セット項目は使用不可です',
	'retry': '再試行',
	'widgetConditionalFormatLabel': '条件付き書式制御の切り替え',
	'widgetConditionalFormatTitle': '条件付き書式の色の編集',
	'crosstabName': 'クロス集計',
	'WidgetLabelWithDescripion': '%{label}. %{description}',
	'value_is_not_available': '適用外',
	'summaryLabel': '%{value} の値は %{label}',
	'infographicLabel': '%{value} の値は %{label}',
	'warning': '警告',
	'swapRowsAndColumns': '行と列の交換',
	'hideSummariesLabel': '要約の非表示',
	'showSummariesLabel': '要約の表示',
	'hideRowColumn': '非表示',
	'showAllRowColumn': 'すべて表示',
	'dataAssetPropertiesLabel': '視覚化のプロパティー',
	'evAdd': '列の追加',
	'evCollapse': '省略',
	'evColumns': '列',
	'evLocalFilters': 'ローカル・フィルター',
	'evExpand': '展開',
	'evFilterTooltip': 'フィルター',
	'missingColumn': '欠落しています: %{columnLabel}',
	'missingFiltering': '列のフィルターが欠落しています:',
	'missingDataItem': '参照されているデータ・アイテム "%{dataItemId}" がウィジェットに見つかりません。',
	'heatByLabel': '熱の分類',
	'toolbarChangeVisualization': '視覚化の変更',
	'modellingRelatedTablesNoneFound': '関連した表が見つかりません',
	'processing': '処理中...',
	'errorCellWarning': '一部の集計値を計算できませんでした。',
	'aggregateTypeToggler': '集計タイプの表示',
	'maxColumnsExceeded': '列の最大数を超過しています。 %{columns} がドロップされました。',
	'unboundColumns': '次の列を使用できません: %{columns}。',
	'unboundColumn': '次の列を使用できません: %{columns}。',
	'recommendRequestFailed': '推奨要求が失敗しました。 管理者に連絡してください。',
	'visualizationDoesNotSupportOLAP': 'OLAP データ・ソースに基づくこの視覚化は作成できません。 サポートされている別のデータ・ソースを使用してください。',
	'showDataBehindVizLabel': 'データの表示',
	'showDataBehindVizNotSupportedLabel': 'この視覚化タイプではデータの表示はサポートされません。',
	'exploreData': '閲覧...',
	'newExplore': '新規閲覧ビュー',
	'thumbnails_error_fetching': 'サムネイルの取り出し中にエラーが生じました',
	'loadedThumbnailImage': '%{visType} 視覚化サムネイル・イメージをロードしました',
	'autobinAxisLabel': 'グループ',
	'recommended_visualizations': '推奨される視覚化',
	'all_visualizations': 'すべての視覚化',
	'edit': '編集',
	'selectTargetDialogTitle': 'ドリルスルーのターゲットの選択',
	'noTargetInCM': 'ドリルスルーのターゲットが見つかりません',
	'errorDrillDefinition': 'ドリルスルー定義の追加または編集中に、何らかの問題が発生しました。',
	'errorDrillToTarget': '"%{targetName}" にドリルする際にエラーが発生しました',
	'drillThroughMappingViewLabel': 'ダッシュボードからターゲット・レポートのプロンプトに列を割り当てる',
	'drillthroughScopeRadioLabel': 'この定義の適用先:',
	'drillthroughScopeRadioOptionVisualization': 'この視覚化のみ',
	'drillthroughScopeRadioOptionConnection': '同じデータ・ソースを使用する同じ接続内の視覚化',
	'drillthroughScopeRadioOptionDashboard': '同じデータ・ソースを使用する、%{perspective} 上の任意の視覚化',
	'drillThroughParametersColumnTitle': '"%{targetName}" プロンプト:',
	'drillThroughMetadataColumnTitle': '"%{boardName}" データ列:',
	'drillThroughDefinitionNoParameter': 'ドリルスルーのターゲットにプロンプトがありません。',
	'drillThroughDefinitionErrorQueryingReport': 'ターゲット・レポートの問題を修正してから、もう一度ドリルスルー定義を作成してみてください。',
	'drillThroughDefinitionErrorDlgTitle': '問題が発生しました',
	'dlg_back': '戻る',
	'dlg_close': '閉じる',
	'dlg_ok': 'OK',
	'dlg_cancel': 'キャンセル',
	'dlg_apply': '適用',
	'dlg_create': '作成',
	'dlg_done': '完了',
	'drillthrough_unsaveMsg': '"%{name}" を保存せずに続行しますか?',
	'drillthrough_jumpTo': 'ドリルスルー定義: %{name}',
	'drillthrough_jumpToLabel': 'ドリルスルー',
	'drillthrough_manage': '管理...',
	'drillthrough_addNewTarget': '新規ドリルスルー定義の追加',
	'drillthrough_manageJumpPaths': 'ドリルスルー定義の管理',
	'drillthrough_manageJumpPaths_edit': '"%{name}" の編集',
	'drillthrough_manageJumpPaths_delete': '"%{name}" の削除',
	'drillthrough_manageAddAnotherTarget': '別のドリルスルー定義の追加',
	'drillthrough_manageConfirmeDeleteDrillTargetTitle': '削除の確認',
	'drillthrough_manageConfirmeDeleteDrillTarget': 'ドリルスルー "%{name}" を削除しますか?',
	'drillthrough_definitionDuplicateDrillTargetErrorTitle': '重複するドリルスルー名',
	'drillthrough_definitionMessage': 'ドリルスルー "%{name}" はすでに存在します。別の名前を指定してください',
	'drillthrough_jumpToTarget_notFound': 'ドリルスルーの "%{name}" にターゲットが見つかりません',
	'drillThroughDefinitionNoParameterSubTitle': 'コンテキストがターゲット・レポートに渡されません。',
	'drillthrough_titleLabel': '名前',
	'drillthrough_create_dialogTitle': 'ドリルスルー定義の作成',
	'drillthrough_edit_dialogTitle': 'ドリルスルー定義の編集',
	'drillthrough_subTitle': 'ソースの視覚化のコンテキストが、ターゲット %{perspective} のフィルター処理に使用されます。',
	'drillthrough_selectColumn': '列の選択',
	'noPrompt': 'プロンプトなし',
	'promptDialog': '%{promptType} プロンプト・ダイアログ',
	'formatAutoDescription': '「自動」を使用すると、データ・ソースまたは視覚化から継承されたフォーマットが指定されます。',
	'formatDefaultDescription': '「デフォルト」を使用すると、システムから継承されたフォーマットが指定されます',
	'createCustomGroupAction': 'データ・グループの作成',
	'removeCustomGroupAction': 'データ・グループの削除',
	'editCustomGroupAction': 'データ・グループの編集',
	'renameCustomGroupAction': 'データ・グループの名前変更',
	'createCustomGroupErrorToast': 'データ・グループを作成できませんでした。',
	'removeCustomGroupErrorToast': 'データ・グループを削除できませんでした。',
	'editCustomGroupErrorToast': 'データ・グループを編集できませんでした。',
	'renameCustomGroupErrorToast': 'データ・グループを名前変更できませんでした。',
	'customGroupLabel': 'データ・グループの作成',
	'ungroupCustomGroupLabel': 'グループ化解除',
	'renameCustomGroupLabel': '名前変更',
	'createCustomGroupLabel': '作成',
	'customGroupingLabel': '%{columnLabel} (グループ)',
	'createCustomSort': 'カスタム・ソートの作成',
	'createCustomSortTitle': '%{name}',
	'createCustomSortDesc': '使用可能なアイテムを選択し、それらを並べ替えてカスタム・ソートを作成します。',
	'availableItems': '使用可能なアイテム',
	'selectAll': 'すべてを選択',
	'customSortOrder': 'カスタム・ソート順',
	'selectAvailableItemsDesc': '使用可能なアイテムを選択し、それらをここで並べ替えます。',
	'moveToTop': '一番上へ移動',
	'clear': 'クリア',
	'sortRemainingItemsBy': '次の条件で残りのアイテムをソート',
	'removeAll': 'すべて削除',
	'resetTooltip': 'すべてのアイテムが %{customSortOrder} リストから削除されます。また、%{sortRemainingItemsBy} ドロップダウンがデフォルトに戻ります。',
	'manyItemsWarning': '選択するアイテムが多いと、ダッシュボードのパフォーマンスに影響を与える場合があります。',
	'manyItemsSelected': '%{maxItems} 個を超えるアイテムが選択されました。これは、ダッシュボードのパフォーマンスに影響を与える可能性があります。',
	'somethingWentWrong': '何か誤りがあるようです。',
	'tryAgain': '再試行してください',
	'customSortLabel': 'カスタムのソート',
	'applyError': '%{action} を適用できません。',
	'searchReturnedNoResults': '検索で結果が返されませんでした。',
	'extVisSystem': 'システム',
	'extVisCustom': 'カスタム',
	'customVisTestVisualization': '視覚化テスト',
	'extVisCustomVisPreview': 'プレビュー',
	'extVisCustomPreviewWidgets': '開発者ウィジェット',
	'extVisCustomVVisualization': '視覚化',
	'extVisCustomVisuals': 'カスタム・ビジュアル',
	'noPermissionToManage': 'カスタム視覚化を管理する権限がありません。',
	'extVisCustomUpdate': '更新',
	'extVisCustomDelete': '削除',
	'extVisNoCustomVisuals': 'カスタム・ビジュアルなし',
	'extVisNoCustomVisualsMsg': 'カスタム・ビジュアルは組織内に現在ありません',
	'extVisAddCustomVisual': 'カスタム・ビジュアルの追加',
	'extVisNoCustomVisualsAdminMsg': 'カスタム・ビジュアルは現在ありません。 始めるには 1 つ追加してください',
	'extVisNoSDKConnection': 'ローカル・ファイルへの接続が作成されませんでした',
	'extVisNoSDKPreviewMsg': '視覚化をプレビューするには、接続を確立してください。',
	'extVisMore': '詳細表示',
	'extVisDeleteDialogTitle': 'カスタム・ビジュアルの削除',
	'extVisDeleteDialogBody': '本当にこのカスタム視覚化を削除しますか? これは他のダッシュボードおよびレポートで使用されている可能性があります。',
	'extVisDeleteConfirmation': 'カスタム・ビジュアルが削除されました。',
	'extVisDeleteError': 'カスタム・ビジュアルを削除できませんでした。 %{msg}',
	'extVisCloseToast': '今すぐ閉じる',
	'extVisAdd': 'カスタム・ビジュアルが正常に追加されました。',
	'extVisAddError': 'カスタム・ビジュアルを追加できませんでした。 %{msg}',
	'extVisUpdate': 'カスタム・ビジュアルが正常に更新されました。',
	'extVisUpdateError': 'カスタム・ビジュアルを更新できませんでした。 %{msg}',
	'extVisAddProgress': '%{name} のインポート中',
	'extVisUpdateProgress': '%{name} の更新中',
	'extPermissionTitle': 'アクセスが制限されているかカスタム・ビジュアルが削除済み',
	'extPermissionBody': 'このカスタム・ビジュアルは、削除されているか、またはアクセスが制限されているために表示できません。',
	'customVizSaveWarning': 'カスタム・ビジュアルを保存できません。 これらのカスタム・ビジュアルはインポートされていません。',
	'schematicTestCaption': '図式テスト',
	'schematicServiceRequestError': '図式サービス・エラー',
	'extVisPreviewMessage': 'これはプレビューです。視覚化はまだ製品に追加されていません。',
	'kpiTargetWithDistance': '%{value} (%{distance})',
	'kpiDistanceUndefined': '未定義',
	'kpiDefaultTargetLabel': '目標値',
	'kpiNonNumericTarget': 'ターゲット値は数値でなければなりません。',
	'kpiManualTargetSlotFilled': 'フィールドで適用される値',
	'kpiAutoValueSize': '自動',
	'kpiUnableDrawSparklineLabel': 'スパークライン・グラフを描画できません',
	'kpiUnableDrawSparklineInfo': 'スパークライン・グラフには少なくとも 2 つの時点が必要です。 スパークライン・グラフを表示するには、データを変更するか、フィルターを調整します。',
	'conditionalFormattingTextColor': 'テキストの色',
	'suppression': '消去',
	'suppressNone': 'なし',
	'suppressRowsAndColumns': '行と列',
	'suppressRows': '行',
	'suppressColumns': '列',
	'enableSuppression': '消去を有効にする',
	'disableSuppression': '消去を無効にする',
	'loadVisDefinitionError': '視覚化 %{id} の定義をロードできません。',
	'emptyVisualization': '視覚化が空です',
	'expandCollapse': '展開と省略',
	'expandBtnLabel': '展開',
	'collapseBtnLabel': '省略',
	'prop_sizeInputNonNumericValue': '値は数値でなければなりません。',
	'prop_sizeValueShouldBeHigher': '%{value} より大きい値でなければなりません。',
	'fontPropLabel': 'フォント・ファミリー',
	'fontSizePropLabel': 'フォント・サイズ',
	'sectionItemAxisTitle': '項目軸タイトル',
	'sectionItemAxisLabel': 'アイテム軸ラベル',
	'sectionValueAxisTitle': '値軸タイトル',
	'sectionValueAxisLabel': '値軸ラベル',
	'styletext-widget.legend': '凡例',
	'styletext-itemAxis.ticks.labels': '軸ラベル',
	'styletext-valueAxis.title': '軸のタイトル',
	'styletext-itemAxis.title': '軸のタイトル',
	'styletext-labels': 'データ・ラベル',
	'styletext-valueAxis.line.title': '行のタイトル',
	'styletext-cellValue': '値',
	'styletext-values': '値',
	'styletext-rowHeading': '行見出し',
	'styletext-columnHeading': '列見出し',
	'fontFamily': 'ファミリー',
	'fontSize': 'サイズ',
	'visExportFileName': '視覚化',
	'ds-missingDataSet': 'データ・セットが見つかりませんでした。データ・セットが正常に作成されていることを確認してください。',
	'ds-missingDashboardId': 'データ・セットを作成する前にダッシュボードを保存してください。',
	'ds-unsupportedDataSourceType': '%{type} データ・ソース・タイプはサポートされていません。',
	'dataCache': 'データ・キャッシュ',
	'dataCache_on': 'オン',
	'dataCache_off': 'キャッシュなし',
	'dataCache_auto': '自動',
	'queryOptimization': 'クエリーの最適化'
});
